import React from "react";
import { List, Card, Dropdown, Icon, Label } from "semantic-ui-react";
import { dispatch } from "@rematch/core/";
import { history } from '../../../../helpers';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import LoadingComponent from "../../../common/LoadingComponent";


class EmailTemplate extends React.Component {

    state = {
        isGlobalTemplateValid: null,  // Default state is null
        isLoading: true,  // Add loading state
    }
    
    componentDidMount() {
        dispatch.app.baseModuleType("Workspace");
    }

   
    async componentWillMount() {
        await dispatch.customTemplates.fetchTemplates();
        await dispatch.customTemplates.fetchGlobalTemplate();
        const globalTemplate = this.props.globalTemplate || {};
        const isValid = globalTemplate && globalTemplate._id && globalTemplate.type === "globalHeader";
        this.setState({ 
            isGlobalTemplateValid: isValid,
            isLoading: false,  // Set loading to false after data is loaded
        });
    }

    openGlobalEmail = (e) => {
        history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_wsSetting/emailTemplates/global`)
    }

    editEmail = (e, data, item) => {
        let message = <div className="confirmMessage">
        <h3>Edit Template</h3>
        <label>{item.name}</label>
        <p>Are you sure that you wish to edit this template?</p>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                dispatch.customTemplates.fetchTemplateId(item._id);
                history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_wsSetting/emailTemplates/email/${item._id}`)
            }
        });
    }

    deleteEmail = async (e, data, item) => {
        dispatch.customTemplates.setSelectedTemplateUsed(false);
        await dispatch.customTemplates.checkTemplateInUse(item._id);
        if(this.props.selectedTemplateUsed){
            let message = <div className="confirmMessage">
                <h3>Template is attached in playbook activity</h3>
            </div>
            toastr.confirm(message, {
                onOk: () => {
                }
            });
        } else {
            let message = <div className="confirmMessage">
            <h3>Delete Template</h3>
            <label>{item.name}</label>
            <p>Are you sure that you wish to do this?</p>
            <span >This action is not reversible</span>
            </div>
            toastr.confirm(message, {
                onOk: () => {
                    dispatch.customTemplates.deleteTemplateId(item._id);
                }
            });
        }
    }

    render() {
    const { isGlobalTemplateValid, isLoading } = this.state;
    const AddGlobalTemplate = <Card style={{ margin: "0 0 15px 0" }}>

        <Card.Content className="pad_0" >
            <List selection divided verticalAlign='middle'
            >
                <List.Item className="multiLine"
                    onClick={(e) => this.openGlobalEmail(e)}
                    style={{
                        backgroundColor: "#fafafa",

                    }}>
                    <List.Content floated='right'>
                        <Icon name="arrow right" />
                    </List.Content>
                    <List.Content>
                        {isLoading?(
                            <LoadingComponent active={isLoading} message="Loading" />
                        ):(
                            <div style={{display: 'flex',alignItems: 'center'}}>
                                <div className="circle" style={{backgroundColor: isGlobalTemplateValid ? "green" : "gray",}}/>
                                <div>
                                    <List.Header >Global Email template</List.Header>
                                    <span >Include global account .......</span>
                                </div>
                            </div>

                        )}
                        
                    </List.Content>
                </List.Item>
            </List>
        </Card.Content>
    </Card>


    const RenderTemplates = this.props.customNotificationArray.data && this.props.customNotificationArray.data.map((m, i) => {
        return <Card style={{ margin: "0 0 15px 0" }}>
            {/* <Card.Header>{m.name} </Card.Header> */}
            <Card.Content className="pad_0">
                <List divided verticalAlign='middle'>
                        <React.Fragment>
                            <List.Item className="singleLine mar_0">
                                <List.Content floated='right'>
                                    <Dropdown
                                        icon="ellipsis vertical"
                                        pointing="right"
                                    >
                                        <Dropdown.Menu>
                                            <Dropdown.Menu scrolling>
                                                <Dropdown.Item text='Edit' onClick={(e, data) => this.editEmail(e, data, m)}  ></Dropdown.Item>
                                                <Dropdown.Item text='Delete' onClick={(e, data) => this.deleteEmail(e, data, m)}   ></Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </List.Content>
                                <List.Content >
                                    <List.Header > {m.name}</List.Header>
                                </List.Content>
                            </List.Item>

                        </React.Fragment>
                    {/* })} */}
                </List>
            </Card.Content>
        </Card>
    })


    return (
        <div className="general-setting">
            <div>
                {AddGlobalTemplate}
            </div>
            <div>
                {RenderTemplates}
            </div>
        </div>
    );
    }
}


export default withRouter(EmailTemplate);